/* eslint-disable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment */
import { type Observer, type Operation, type FetchResult, ApolloLink, Observable } from '@apollo/client'
import type { TGqlOperationName } from 'gql/names.types'

export interface ITrackOperationStatusCallbacks {
  onStartOperation: (operationName: TGqlOperationName) => void
  onEndOperation: (operationName: TGqlOperationName) => void
  onOperationError: (operationName: TGqlOperationName, error: string | null) => void
}

export const createTrackOperationStatusLink = (
  { onStartOperation, onEndOperation, onOperationError }: ITrackOperationStatusCallbacks,
  predicate?: (operation: Operation) => boolean,
) => {
  return new ApolloLink((operation, forward) => {
    const operationName = operation.operationName as TGqlOperationName

    const observable = forward(operation)

    if (!predicate || predicate(operation)) {
      onStartOperation(operationName)

      return new Observable<FetchResult>((observer: Observer<FetchResult>) => {
        const sub = observable.subscribe({
          next: (result: FetchResult) => {
            const error = result.errors?.[0] ?? null

            if (error) {
              onOperationError(operationName, error.message)
            }
            observer.next(result)
          },
          error: (error: Error) => {
            onOperationError(operationName, error.message)
            observer.error(error)
          },
          complete: () => {
            observer.complete()
          },
        })

        return () => {
          onEndOperation(operationName)
          sub.unsubscribe()
        }
      })
    }

    return observable
  })
}
